import { CommonReply } from "@/proto/Common_pb";
import * as Auth_pb from "../proto/Auth_pb";
import { AuthServicesClient } from "../proto/WebServicesServiceClientPb";
import { RpcError } from "grpc-web";
const authClient = new AuthServicesClient(`${process.env.REACT_APP_PUBLIC_API_HOST}`);

export async function loginRequestApi(email: string, password: string) {
  const req = new Auth_pb.LoginRequest();
  req.setEmail(email);
  req.setPassword(password);
  try {
    return await authClient.login(req, null);
  } catch (err) {
    return err as RpcError;
  }
}
export async function logoutRequestApi(){
  const req = new Auth_pb.LogoutRequest();
  try {
    return await authClient.logout(req, null);
  } catch (err) {
    return err as RpcError;
  }
}

export async function registerRequestApi(email: string, phone_number: string, name: string, password: string, programid: string) :Promise<Auth_pb.RegisterReply| RpcError>{
  const registerReq = new Auth_pb.RegisterRequest();
  registerReq.setEmail(email)
    .setPhoneNumber(phone_number)
    .setName(name)
    .setPassword(password)
    .setProgramid(programid);
  try {
    return await authClient.register(registerReq, null);
  } catch (err) {
    return err as RpcError;
  }
};

export async function confirmRegisterEmailApi(urlKey: string) :Promise<CommonReply | RpcError> {
  const confirmRegisterEmailReq = new Auth_pb.ConfirmRegisterEmailRequest();
  confirmRegisterEmailReq.setUrlKey(urlKey);
  try {
    return await authClient.confirmRegisterEmail(confirmRegisterEmailReq, null);
  } catch (err) {
    return err as RpcError;
  }
}

export async function redeemTokenApi(urlKey: string) :Promise<Auth_pb.AuthReply | RpcError> {
  const redeemReq = new Auth_pb.RedeemTokenRequest();
  redeemReq.setMailStateId(urlKey);
  try {
    return await authClient.redeemToken(redeemReq, null);
  } catch (err) {
    return err as RpcError;
  }
}

export async function resendRegisterEmailApi(userId: string): Promise<Auth_pb.ResendRegisterEmailReply | RpcError> {
  const resendRegisterEmailReq = new Auth_pb.ResendRegisterEmailRequest();
  resendRegisterEmailReq.setUserId(userId);
  try{
    return await authClient.resendRegisterEmail(resendRegisterEmailReq, null);
  } catch(err) {
    return err as RpcError;
  }
}

export async function checkRegisterConfirmStateApi(userId: string):Promise<Auth_pb.CheckRegisterConfirmStateReply | RpcError>{
  const checkRegisterConfirmStateReq = new Auth_pb.CheckRegisterConfirmStateRequest();
  checkRegisterConfirmStateReq.setUserId(userId);
  try{
    return await authClient.checkRegisterConfirmState(checkRegisterConfirmStateReq , null)
  } catch(err){
    return err as RpcError;
  }
}


